<template>
  <div class="store-system-warpper">
    <!-- banner -->
    <div class="store-system-banner">
      <img width="100%" :src="bannerList.imgUrl" alt="" srcset="">
      <div class="store-system-banner-text">
        <p>做好业绩统计分析</p>
        <p>让经营决策<span> 有据可依</span></p>
        <p>统计数据源自上百张美容院真实表格，自定义报表，数据随心查</p>
      </div>
    </div>

    <div class="platform-advantages">
      <p class="platform-advantages-title" id="yiyueSaas">意约saas平台让产品自己会说话</p>
      <div class="platform-advantages-main">
        <ul class="platform-advantages-main-left">
          <li @click="platformActive = item.id" :class="platformActive == item.id ? 'active' : ''" v-for="item in platformList" :key="item.id">{{item.name}}</li>
        </ul>
        <div v-if="platformActive == 0" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop.png" alt="" srcset="" />
                <span class="ml11 ft22">顾客管理</span>
              </p>
              <p>帮助美容及泛美容行业更好的做顾客服务和管理</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad1.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad1-2.png" alt="" />
                <div>
                  <p class="hovercolor">智能分类</p>
                  <p class="line2">根据顾客消费能力，到店频次， 自动归类</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad2.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad2-2.png" alt="" />
                <div>
                  <p class="hovercolor">动态跟踪</p>
                  <p class="line2">全方位跟踪顾客到店动态、消费动态</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad3.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad3-2.png" alt="" />
                <div>
                  <p class="hovercolor">待办事项提醒</p>
                  <p class="line2">自动提醒不漏掉重要客情</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w42 h52" src="../../assets/images/platforad4.png" alt="" />
                <img class="platform-img2 w42 h52" src="../../assets/images/platforad4-2.png" alt="" />
                <div>
                  <p class="hovercolor">顾客分配</p>
                  <p class="line2">按员工能力分配零死角掌上管理顾客</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad5.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad5-2.png" alt="" />
                <div>
                  <p class="hovercolor">模版式日志</p>
                  <p class="line2">定制顾客日志模板全流程管理顾客</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w42 h52" src="../../assets/images/platforad6.png" alt="" />
                <img class="platform-img2 w42 h52" src="../../assets/images/platforad6-2.png" alt="" />
                <div>
                  <p class="hovercolor">消费分析</p>
                  <p class="line2">快速查看顾客消费到店记录</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="platformActive == 1" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop2.png" alt="" srcset="" />
                <span class="ml11 ft22">目标管理</span>
              </p>
              <p>设置并管理员工目标，月中、月末推送，达成情况和差额一目了然</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>
          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad21.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad21-2.png" alt="" />
                <div>
                  <p class="hovercolor">目标设置</p>
                  <p class="line2">精细化设定员工目标，管理一触即发</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad22.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad22-2.png" alt="" />
                <div>
                  <p class="hovercolor">目标跟进</p>
                  <p class="line2">目标达成情况和差额一目了然</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad23.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad23-2.png" alt="" />
                <div>
                  <p>目标推送</p>
                  <p class="line2">目标提醒小助理，陪伴你大步向目标迈进</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="platformActive == 2" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop3.png" alt="" srcset="" />
                <span class="ml11 ft22">收银系统</span>
              </p>
              <p>更加懂你的收银系统，操作流畅顺滑，好用到停不下来</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>
          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad31.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad31-2.png" alt="" />
                <div>
                  <p class="hovercolor">云端收银</p>
                  <p class="line2">智能化的云端收银系统，更高效快捷</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad32.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad32-2.png" alt="" />
                <div>
                  <p class="hovercolor">一键收款</p>
                  <p class="line2">方便简洁，收款一键搞定</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad33.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad33-2.png" alt="" />
                <div>
                  <p class="hovercolor">移动支付</p>
                  <p class="line2">移动支付，让支付更便捷</p>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad34.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad34-2.png" alt="" />
                <div>
                  <p class="hovercolor">收银记账</p>
                  <p class="line2">用心记录你经营的每一天</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad35.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad35-2.png" alt="" />
                <div>
                  <p class="hovercolor">卡金监管</p>
                  <p class="line2">银行监管卡进，让用户更放心门店</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad36.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad36-2.png" alt="" />
                <div>
                  <p class="hovercolor">低汇率</p>
                  <p class="line2">低汇率让门店收入增加</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="platformActive == 3" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop4.png" alt="" srcset="" />
                <span class="ml11 ft22">预约系统</span>
              </p>
              <p>拖拽式预约面板，操作有趣，简单快捷</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad41.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad41-2.png" alt="" />
                <div>
                  <p class="hovercolor">拖拽式预约面板</p>
                  <p class="line2">拖拽式操作，有趣便捷，超级好用易上手</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad42.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad42-2.png" alt="" />
                <div>
                  <p class="hovercolor">手机预约</p>
                  <p class="line2">随时随地地想约就约，方便快捷</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad43.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad43-2.png" alt="" />
                <div>
                  <p class="hovercolor">预约提醒</p>
                  <p class="line2">即时告知您的顾客和员工预约变动情况</p>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad44.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad44-2.png" alt="" />
                <div>
                  <p class="hovercolor">订单管理</p>
                  <p class="line2">实时查看你的门店经营状态，助你更好的管理门店</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad45.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad45-2.png" alt="" />
                <div>
                  <p class="hovercolor">订单评价</p>
                  <p class="line2">用户评价订单，了解用户对理发师满意度</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">

            </el-col>
          </el-row>
        </div>

        <div v-if="platformActive == 4" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop5.png" alt="" srcset="" />
                <span class="ml11 ft22">微信小程序</span>
              </p>
              <p>集门店拓客引流、线上商城、分销裂变10+种运营神器，助力门店互联网化运营</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad51.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad51-2.png" alt="" />
                <div>
                  <p class="hovercolor">店铺装修</p>
                  <p class="line2">商城风格、皮肤颜色自由设定</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad52.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad52-2.png" alt="" />
                <div>
                  <p class="hovercolor">在线商城</p>
                  <p class="line2">拼团抢购、全面满足你的线上营销需求</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad53.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad53-2.png" alt="" />
                <div>
                  <p class="hovercolor">拓客锁客</p>
                  <p class="line2">员工推广、顾客分销、新客有礼10+营销策略</p>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 h50 w35" src="../../assets/images/platforad54.png" alt="" />
                <img class="platform-img2 h50 w35" src="../../assets/images/platforad54-2.png" alt="" />
                <div style="margin-left:25px">
                  <p class="hovercolor">轻推送</p>
                  <p class="line2">消息推送、签到有礼，自助开单支付导流关注公众号</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">

            </el-col>
            <el-col :span="8">

            </el-col>
          </el-row>
        </div>

        <div v-if="platformActive == 5" class="platform-advantages-main-right">
          <div class="platform-advantages-main-right-top">
            <div class="platform-advantages-main-right-top-left">
              <p>
                <img class="w40" src="../../assets/images/platformTop6.png" alt="" srcset="" />
                <span class="ml11 ft22">考勤系统</span>
              </p>
              <p>帮你建立完善的考勤机制，有规矩才能成方圆</p>
            </div>
            <el-button class="platform-advantages-main-right-top-right">进入演示</el-button>
          </div>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad61.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad61-2.png" alt="" />
                <div>
                  <p class="hovercolor">手机打卡</p>
                  <p class="line2">手机打卡上班，智能化管理</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad62.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad62-2.png" alt="" />
                <div>
                  <p class="hovercolor">考勤日历</p>
                  <p class="line2">日历表式考勤，直观展示考勤数据</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad63.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad63-2.png" alt="" />
                <div>
                  <p class="hovercolor">统计报表</p>
                  <p class="line2">数据化统计员工上班打卡情况</p>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="platform-advantages-main-item">
            <el-col :span="8">
              <div class="platform-advantages-main-item-box">
                <img class="platform-img1 w50 h50" src="../../assets/images/platforad64.png" alt="" />
                <img class="platform-img2 w50 h50" src="../../assets/images/platforad64-2.png" alt="" />
                <div>
                  <p class="hovercolor">排班管理</p>
                  <p class="line2">手机PC都可管理，不受时间、地点限制</p>
                </div>
              </div>
            </el-col>
            <el-col :span="8">

            </el-col>
            <el-col :span="8">

            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="programme">
      <p class="programme-title">意约美业方案，解决营销增长问题</p>
      <p class="programme-explain">打造全方位立体式美业方案，涵盖多模式、多体系的具有准对性的痛点解决手段</p>

      <div class="programme-box-center">
        <ul class="programme-tab">
          <li :style="{'color':programmeTabActive == item.id ? '#FF9141' : ''}" @click="programmeTabActive = index" v-for="(item,index) in programmeTab" :key="item.id">{{item.name}}</li>

          <!-- <span :style="{'left':`calc(${programmeTabActive*25}% + 105px)`}" class="programme-tab-active"></span> -->
          <span :style="{'left':`${programmeTabActive*25}%`}" class="programme-tab-active ml105"></span>
        </ul>

        <div class="programme-main clearfix" v-if="programmeTabActive == 0">
          <div class="programme-main-item" v-for="item in programmeList" :key="item.id">
            <div class="programme-main-img"><img class="w48" :src="item.image" alt=""></div>
            <p>{{item.title}}</p>
            <p class="line2">{{item.explain}}</p>
          </div>
        </div>

        <div class="programme-main2 clearfix" v-if="programmeTabActive == 1" style="height:285px;diaplay:inline-block">
          <div class="programme-left">
            <p>全网平台拓客</p>
            <p>公域流量无限拓客，一键触达全网，多平台无缝对接，把所有流量平台的目标客户尽收囊中</p>

            <el-dropdown @command="handleCommand">
              <button class="programme-button">{{programmeNum == 1 ? "公域营销获客" : "私域裂变收现"}} <i class="el-icon-arrow-down el-icon--right"></i></button>
              <el-dropdown-menu slot="dropdown" class="w200">
                <el-dropdown-item :command="1">公域营销获客</el-dropdown-item>
                <el-dropdown-item :command="2">私域裂变收现</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="display:inline-block" class="w617">
            <img v-if="programmeNum == 1" class="h285" src="../../assets/images/storeIMG.png" alt="" srcset="">
            <img v-else class="h285" src="../../assets/images/storeIMG.png" alt="" srcset="">
          </div>
        </div>
        <div class="programme-main clearfix" v-if="programmeTabActive == 2">
          <div class="programme-main-item" v-for="item in programmeList2" :key="item.id">
            <div class="h50" v-if="item.id == 3">
              <img class="w40" :src="item.image" alt="">
            </div>
            <div class="h50" v-else>
              <img class="w48" :src="item.image" alt="">
            </div>
            <p>{{item.title}}</p>
            <p class="line2">{{item.explain}}</p>
          </div>
        </div>
        <div class="programme-main clearfix" v-if="programmeTabActive == 3">
          <div class="programme-main-item" v-for="item in programmeList3" :key="item.id">
            <img class="w48" :src="item.image" alt="">
            <p>{{item.title}}</p>
            <p class="line2">{{item.explain}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="customer-presentation">
      <p class="customer-presentation-title">我们的客户是产品优秀的最佳证明</p>
      <p class="customer-presentation-expain">客户的信任是我们产品改进最大的动力，优秀的产品也是客户管理企业最好的工具</p>
      <div class="customer-presentation-main">
        <el-row>
          <el-col :span="12">
            <div class="customer-presentation-main-text">
              <img :src="customerSaid[0].imgUrl" alt="" srcset="" />
            </div>
          </el-col>
          <el-col :span="12" class="customer-presentation-main-right">
            <p class="line1">{{customerSaid[0].brand}}</p>
            <p class="line2">{{customerSaid[0].abstracts}}</p>

            <div class="customer-presentation-main-right-tow">
              <img class="w67" style="border-radius:50%" :src="customerSaid[0].headUrl" alt="" srcset="" />
              <div>{{customerSaid[0].name}}</div>
            </div>
            <p class="customer-presentation-main-right-three line3">{{customerSaid[0].content}}</p>
          </el-col>
        </el-row>

        <el-carousel indicator-position="outside" :autoplay="false">
          <el-carousel-item v-for="(item,index) in Math.ceil(customerSaid.length/3)" :key="index">
            <div class="customer-presentation-footer-img mt54">
              <div class="customer-presentation-item" v-for="(item2,index2) in customerSaid.slice(3*index,3*(index+1))" :key="index2">
                <img style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:100%" :src="item2.imgUrl" alt="" srcset="" />
                <div class="customer-presentation-footer-img-box">
                  <p class="line1">{{item2.name}}</p>
                  <p class="line1">{{item2.abstracts}}</p>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <div class="carousel-height310"></div>
        </el-carousel>
      </div>
    </div>

    <div class="download-app">
      <p>下载客户端，在各设备间无缝衔接</p>
      <p>不管是桌面端还是手机端，你都能随时管理门店，掌握顾客资料</p>

      <div class="download-main clearfix">
        <div class="download-main-item">
          <p class="download-title">PC客户端下载</p>
          <div class="download-main-box">
            <a href="javascript:;" class="download-main-box-btn">
              点击下载<i class="el-icon-download"></i>
            </a>

            <img class="downloadimg1" src="../../assets/images/down1.png" alt="" srcset="">
          </div>
        </div>
        <div class="download-main-item">
          <p v-if="!downScan2" class="download-title">苹果IPAD下载</p>
          <div v-if="!downScan2" class="download-main-box">
            <span>扫码下载</span>

            <img class="downloadimg2" src="../../assets/images/down2.png" alt="" srcset="">
          </div>
          <img v-if="!downScan2" class="down-scan-img" @mouseover="downScan2 = !downScan2" src="../../assets/images/downScan.png" alt="" srcset="" />
          <div class="down-scan-mask" v-if="downScan2">
            <img class="down-scan-img" @mouseout="downScan2 = !downScan2"  src="../../assets/images/downScan.png" alt="" srcset="" />
            <img class="w160" src="../../assets/images/wxchart.png" alt="" srcset="" />
          </div>
        </div>
        <div class="download-main-item">
          <p v-if="!downScan3" class="download-title">员工手机APP</p>
          <div v-if="!downScan3" class="download-main-box">
            <span>扫码下载</span>

            <img class="downloadimg3" src="../../assets/images/down3.png" alt="" srcset="">
          </div>
          <img class="down-scan-img" @mouseover="downScan3 = !downScan3" src="../../assets/images/downScan.png" alt="" srcset="" />
            <div class="down-scan-mask" v-if="downScan3">
              <img class="down-scan-img" @mouseout="downScan3 = !downScan3" src="../../assets/images/downScan.png" alt="" srcset="" />
              <img class="w160" src="../../assets/images/wxchart.png" alt="" srcset="" />
            </div>
        </div>
        <div class="download-main-item">
          <p v-if="!downScan4" class="download-title">安卓平板下载</p>
          <div v-if="!downScan4" class="download-main-box">
            <span>扫码下载</span>

            <img class="downloadimg4" src="../../assets/images/down4.png" alt="" srcset="">
          </div>

          <img class="down-scan-img" @mouseover="downScan4 = !downScan4" src="../../assets/images/downScan.png" alt="" srcset="" />
            <div class="down-scan-mask" v-if="downScan4">
              <img class="down-scan-img" @mouseout="downScan4 = !downScan4" src="../../assets/images/downScan.png" alt="" srcset="" />
              <img class="w160" src="../../assets/images/wxchart.png" alt="" srcset="" />
            </div>
        </div>
      </div>
    </div>
    <div class="store-system-foot">
      <img width="100%" src="https://yiyueadmin.oss-cn-shenzhen.aliyuncs.com/website/storeSystem/storeFoot.png" alt="" srcset="">

      <div class="store-system-foot-main">
        <p>与顾客更近一点，生意当更好一些</p>
        <button>马上咨询</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/website";
export default {
  metaInfo:{
		title:'店务营销管理系统、会员软件、营销管理软件、店务Saas-意约数字店务系统',
		meta:[
            {
                name: 'author',
                content:'深圳市意约数字科技有限公司'
            },
            {
                name:'keywords',
                content:'私域会员管理系统、美发美甲店务管理系统、美业软件、美业会员管理系统、美业商学院、美业商城批发采购、大健康管理软件、美容美发美甲用品批发、美容美发管理软件、SPA会所管理软件、美甲管理软件、连锁管理软件 '
            },
            {
                name:'description',
                content:'意约数字是“美业+大健康”互联网SaaS综合服务平台，为大美业机构（医美、美容、美甲、美发、中医养生等）提供一站式数字化门店解决方案，利用互联网技术帮助美业、大健康商家有效解决店务管理、客情管理、裂变营销、渠道分销管理、模式/财税合规等问题，意约数字纳斯达克美业第一股YYDT。'
            }
		]
	},
  data() {
    return {
      activeNum:'',
      downScan1: false,
      downScan2: false,
      downScan3: false,
      platformActive: 0,
      downScan1:false,
      downScan2:false,
      downScan3:false,
      downScan4:false,
      platformList: [
        {
          name: "顾客管理",
          id: 0,
        },
        {
          name: "目标管理",
          id: 1,
        },
        {
          name: "收银系统",
          id: 2,
        },
        {
          name: "预约系统",
          id: 3,
        },
        {
          name: "微信小程序",
          id: 4,
        },
        {
          name: "考勤系统",
          id: 5,
        },
      ],
      programmeTabActive: 0,
      programmeTab: [
        {
          name: "美业定制方案",
          id: 0,
        },
        {
          name: "全平台拓客方案",
          id: 1,
        },
        {
          name: "门店客户关系管理",
          id: 2,
        },
        {
          name: "美业课程体系",
          id: 3,
        },
      ],

      programmeList: [
        {
          image: require("../../assets/images/programmeList1.png"),
          title: "新店开张营销方案",
          explain: "帮助门店开业前锁定和获取第一批种子客户",
          id: 0,
        },
        {
          image: require("../../assets/images/programmeList2.png"),
          title: "周年庆营销方案",
          explain: "每年门店周年庆，策划营销活动激活门店沉睡客户",
          id: 1,
        },
        {
          image: require("../../assets/images/programmeList3.png"),
          title: "节日营销方案",
          explain: "提供各类节日营销活动，提高客户的忠诚度和到店率",
          id: 2,
        },
        {
          image: require("../../assets/images/programmeList4.png"),
          title: "老带新裂变方案",
          explain: "提供各类工具和最新方案，助你三倍裂变高质量精准客",
          id: 3,
        },
        {
          image: require("../../assets/images/programmeList5.png"),
          title: "平台拓客方案",
          explain: "抖音、快手、微信、等各大流量平台持续引流拓客",
          id: 4,
        },
        {
          image: require("../../assets/images/programmeList6.png"),
          title: "异业联盟方案",
          explain: "通过同城异业合作、广告投放助你精准导流高质量客户",
          id: 5,
        },
        {
          image: require("../../assets/images/programmeList7.png"),
          title: "社群裂变方案",
          explain: "提供全套社群营销方案和话术，让老客主动带新客",
          id: 6,
        },
        {
          image: require("../../assets/images/programmeList8.png"),
          title: "更多方案",
          explain: "意约拥有10年美业经验，点击咨询获取更多解决方案",
          id: 7,
        },
      ],
      programmeList2: [
        {
          image: require("../../assets/images/programmeList21.png"),
          title: "会员画像运营体系",
          explain: "建立多维度的用户画像，自动化标签分组，精细化运营",
          id: 0,
        },
        {
          image: require("../../assets/images/programmeList22.png"),
          title: "会员积分体系",
          explain: "建立完善地积分体系和会员专属权益，提升客户的忠诚度",
          id: 1,
        },
        {
          image: require("../../assets/images/programmeList23.png"),
          title: "会员自动回访系统",
          explain: "通过规划化、流程化的回访体系，留住老客户",
          id: 2,
        },
        {
          image: require("../../assets/images/programmeList24.png"),
          title: "锁客系统",
          explain: "完善的服务体系和客情管理流程，牢牢的锁住每一位顾客",
          id: 3,
        },
        {
          image: require("../../assets/images/programmeList25.png"),
          title: "会员口碑营销体系",
          explain: "通过推荐激励等方法，让老客户主动口碑传播带来新客",
          id: 4,
        },
        {
          image: require("../../assets/images/programmeList26.png"),
          title: "升单体系",
          explain: "提供全套的到店升单流程和话术，把低价客变成高价客",
          id: 5,
        },
        {
          image: require("../../assets/images/programmeList27.png"),
          title: "基于画像精准营销",
          explain: "千人千面的营销手段和分级推送，做到营销不伤客",
          id: 6,
        },
        {
          image: require("../../assets/images/programmeList28.png"),
          title: "门店背书",
          explain: "中美协与厦门银行背书增加门店可靠性",
          id: 7,
        },
      ],
      programmeList3: [
        {
          image: require("../../assets/images/programmeList31.png"),
          title: "门店经营",
          explain: "美业门店经营常见问题",
          id: 0,
        },
        {
          image: require("../../assets/images/programmeList32.png"),
          title: "客量增长",
          explain: "助力发型师客量提升",
          id: 1,
        },
        {
          image: require("../../assets/images/programmeList33.png"),
          title: "发型师能力",
          explain: "全方位提升发型师业务和思维能力",
          id: 2,
        },
        {
          image: require("../../assets/images/programmeList34.png"),
          title: "营销思维",
          explain: "客户分层营销，让客户粘性增加的方法论",
          id: 3,
        },
        {
          image: require("../../assets/images/programmeList35.png"),
          title: "股权分配",
          explain: "干货讲透门店股权怎么分配",
          id: 4,
        },
        {
          image: require("../../assets/images/programmeList36.png"),
          title: "项目率提升",
          explain: "烫染率提升的技巧",
          id: 5,
        },
        {
          image: require("../../assets/images/programmeList37.png"),
          title: "发型师IP打造",
          explain: "发型师也要有自己的品牌",
          id: 6,
        },
        {
          image: require("../../assets/images/programmeList38.png"),
          title: "沟通提案能力",
          explain: "增加提案能力，提升发型师的主动升单能力",
          id: 7,
        },
      ],
      customerSaid: [],
      bannerList: {},
      programmeNum: 1,
    };
  },
  created() {
    api.getCustomerSaidList().then((res) => {
      this.customerSaid = res.data;
    });

    this.getbanList();

    if (JSON.stringify(this.$route.query.id)) {
    }
  },
  mounted() {
    
  },
  methods: {
    getbanList() {
      let parms = {
        type: 2,
      };
      api.getBannerList(parms).then((res) => {
        if (res.data && res.data.length > 0) {
          this.bannerList = res.data[0];
        }
      });
    },
    handleCommand(a) {
      console.log(a);
      this.programmeNum = a;
    },
  },
};
</script>

<style lang="less" scoped>
.store-system-warpper {
  width: 100%;
  height: auto;
}
.store-system-banner {
  width: 100%;
  height: auto;
  position: relative;

  & .store-system-banner-text {
    position: absolute;
    left: 13.45%;
    top: 32%;

    & p:nth-child(1) {
      line-height: 32px;
      font-size: 34px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #fefeff;
    }
    & p:nth-child(2) {
      line-height: 45px;
      font-size: 48px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #fefeff;
      margin-top: 19px;
      & span {
        color: #ff9141;
      }
    }
    & p:nth-child(3) {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      margin-top: 20px;
    }
  }
}

.platform-advantages {
  width: 73.1%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 86px;

  & .platform-advantages-title {
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    text-align: center;
    padding-top: 48px;
  }

  & .platform-advantages-main {
    width: 100%;
    margin-top: 80px;
    display: flex;
    & .platform-advantages-main-item {
      margin-top: 20px;
      cursor: pointer;
      & .platform-advantages-main-item-box:hover .platform-img1 {
        display: none;
      }
      & .platform-advantages-main-item-box:hover .platform-img2 {
        display: block;
      }
      & .platform-advantages-main-item-box:hover .hovercolor {
        color: #ff9141;
      }
      & .platform-img2 {
        display: none;
      }
      & > div > .platform-advantages-main-item-box {
        height: 79px;
        padding: 38px 18px 43px 27px;
        box-shadow: 0px 4px 12px 1px rgba(199, 199, 199, 0.5);
        border-radius: 4px;
        display: flex;
        & > div {
          flex: 1;
          margin-left: 15px;

          & > p:nth-child(1) {
            line-height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
          & > p:nth-child(2) {
            line-height: 22px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-top: 18px;
          }
        }
      }
    }
    & .platform-advantages-main-left {
      width: 275px;

      & > li {
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
      }
      & > li.active {
        background: #ff9141;
        color: #ffffff;
        font-size: 22px;
      }
    }

    & .platform-advantages-main-right {
      flex: 1;
      margin-left: 84px;

      & .platform-advantages-main-right-top {
        width: 100%;
        height: auto;
        padding-top: 18px;
        display: flex;
        & .platform-advantages-main-right-top-left {
          flex: 1;
          & p:nth-child(1) {
            width: 100%;
            display: flex;
            align-items: center;
          }
          & p:nth-child(2) {
            line-height: 18px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            color: #999999;
            margin-top: 20px;
          }
        }
        & .platform-advantages-main-right-top-right {
          width: 150px;
          height: 46px;
          background: #ff9141;
          box-shadow: 0px 4px 12px 1px rgba(255, 185, 134, 0.5);
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}

.programme {
  width: 100%;
  height: auto;
  padding: 0 0 69px 0;
  display: block;
  background: url('https://yiyueadmin.oss-cn-shenzhen.aliyuncs.com/website/storeSystem/fangan.png');
  background-size: cover;

  & .programme-button {
    width: 201px;
    height: 47px;
    background: #fff5ee;
    margin-top: 41px;
    border: 1px solid #ff9141;
    box-shadow: 0px 4px 12px 1px rgba(255, 228, 208, 0.5);
    border-radius: 4px;
    font-size: 18px;
    color: #333333;
  }
  & .programme-box-center {
    width: 1200px;
    display: block;
    margin: 0 auto;
    padding-bottom: 69px;
  }
  & .programme-title {
    line-height: 34px;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 35px;
    text-align: center;
    padding-top: 65px;
  }
  & .programme-explain {
    line-height: 22px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 35px;
    text-align: center;
    margin-top: 30px;
  }

  & .programme-tab {
    width: 1200px;
    height: 50px;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
    font-size: 22px;
    font-weight: 400;
    margin: 69px auto 0 auto;
    color: #666666;
    position: relative;
    & li {
      flex: 1;
      text-align: center;
      cursor: pointer;
    }

    & .programme-tab-active {
      width: 90px;
      height: 4px;
      display: inline-block;
      background: #ff9141;
      position: absolute;
      bottom: -1px;
      transition: all 0.5s;
    }
  }

  & .programme-main {
    margin-top: 42px;
    width: 100%;
    height: auto;
    display: inline-block;
& .programme-main-img{height:50px;}
    & .programme-main-item:not(:nth-child(4n + 1)) {
      margin-left: 20px;
    }
    & .programme-main-item:hover p:nth-child(2) {
      color: rgb(255, 145, 65);
    }
    & .programme-main-item:hover{
      box-shadow: 0px 4px 12px 1px rgb(255, 219, 192);
    }
    & .programme-main-item {
      cursor: pointer;
      background: #fff;
      margin-top: 20px;
      width: calc(25% - 55px);
      float: left;
      height: 128px;
      padding: 31px 15px 23px 25px;
      // box-shadow: 0px 4px 12px 1px rgb(255, 219, 192);s

      & p:nth-child(2) {
        line-height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        margin-top: 15px;
      }
      & p:nth-child(3) {
        height: 36px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        margin-top: 14px;
      }
    }
  }

  & .programme-main2 {
    .programme-left{
      width:420px;height:285px;float:left;

      &>p:nth-child(1){
        height: 18px;font-size: 18px;font-family: Source Han Sans CN;font-weight: 400;margin-top:45px;color: #333333;
      }
      &>p:nth-child(2){
        width: 405px;height: 38px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;margin-top:24px;color: #999999;
      }
    }
    margin-top: 42px;
    width: calc(100% - 160px);
    height: auto;
    display: inline-block;
    background: url(../../assets/images/storebg.png);
    background-size: cover;
    padding: 35px 70px 28px 90px;
  }
}
.customer-presentation {
  width: 73.1%;
  height: auto;
  margin: 0 auto;
  padding-top: 79px;

  & .customer-presentation-title {
    text-align: center;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 35px;
  }

  & .customer-presentation-expain {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    text-align: center;
    margin-top: 31px;
  }

  & .customer-presentation-main {
    padding: 50px 101px 25px 101px;
    background: #f7f7f7;
    border-radius: 10px;
    width: calc(100% - 202px);
    margin-top: 114px;

    & .customer-presentation-main-right {
      padding-left: 64px;
      & > p:nth-child(1) {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-top: 28px;
      }
      & > p:nth-child(2) {
        height: 48px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 24px;
        margin-top: 29px;
      }
    }
  }
}
.customer-presentation-main-right-tow {
  display: flex;
  align-items: center;
  margin: 88px 0 0 11px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  & img {
    margin-right: 42px;
  }
}
.customer-presentation-main-right-three {
  height: 64px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  margin-top: 39px;
}
.customer-presentation-footer-img {
  & .customer-presentation-item {
    position: relative;
    height: 226px;
    overflow: hidden;
    border-radius: 10px;
    width:32.5%;
    float: left;
  }
  & .customer-presentation-item:not(:first-child) {
    margin-left:1.25%;
  }
  & .customer-presentation-footer-img-box {
    width: calc(100% - 52px);
    height: auto;
    position: absolute;
    left: 0;
    bottom: 0;
    color: #fff;
    padding: 26px;

    & > p:nth-child(1) {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 18px;
    }
    & > p:nth-child(2) {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;
      margin-top: 14px;
    }
  }
}
.download-app {
  width: 73.1%;
  margin: 104px auto 71px auto;

  & > p:nth-child(1) {
    height: 34px;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 34px;
    text-align: center;
  }
  & > p:nth-child(2) {
    height: 22px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    margin-top: 30px;
    text-align: center;
  }

  &>.download-main{
    width: 100%;
    display: inline-block;
    margin-top: 26px;
    &>.download-main-item{
      width:47.5%;
      height: 220px;
      float: left;
      background-image:url(../../assets/images/downbg.png);
      background-size:100% 100%;
      margin-top: 40px;
      position: relative;

      & .down-scan-img {
        width: 78px;
        position: absolute;
        top: 0;
        right: 0;
      }

      & .down-scan-mask {
        width: 100%;
        height: 100%;
        background: transparent;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &>.download-main-box{
        width:100%;
        height: 148px;
        position: relative;
        &>span{
          height: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #999999;
          position: absolute;
          top:79px;
          left:42px;
        }
        &>.download-main-box-btn{
          width: 150px;
          height: 46px;
          line-height: 46px;
          background: #FF9141;
          box-shadow: 0px 15px 19px 1px rgba(255,231,213,0.6000);
          border-radius: 23px;
          display: inline-block;
          text-align: center;
          font-size: 18px;
          color: #fff;
          position: absolute;
          top:45px;
          left:42px;
        }
        &>.downloadimg1{
          width: 133px;
          height: 128px;
          position: absolute;
          top:15px;
          right:120px;
        }
        &>.downloadimg2{
          width: 152px;
          height: 120px;
          position: absolute;
          top:19px;
          right:50px;
        }
        &>.downloadimg3{
          width:118px;
          height:163px;
          position: absolute;
          top:-2px;
          right:111px;
        }
        &>.downloadimg4{
          width:128px;
          height:143px;
          position: absolute;
          top:5px;
          right:62px;
        }
      }
    }
    & .download-title{
      padding:0 42px;
      line-height:72px;
      height:72px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
    }
    &>.download-main-item:nth-child(2),&>.download-main-item:nth-child(4){
      margin-left: 2.85%
    }
  }
}
.down-scan-img:hover .down-scan-mask {
  top: 0 !important;
  transition: all 0.5s;
}
.store-system-foot {
  width: 100%;
  position: relative;
  & > img {
    display: block;
  }
  & .store-system-foot-main {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    padding-top: 2.5%;
    & > p:nth-child(1) {
      text-align: center;
      line-height: 32px;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
    }
    & > button {
      width: 150px;
      height: 42px;
      background: #ffffff;
      border-radius: 4px;
      border: none;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ff9447;
      margin-top: 1.87%;
    }
  }
}
.customer-presentation-main-text{
  position:relative;overflow:hidden;width: 100%;height: 380px;border-radius:10px;

  &>img{
    position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);height:100%;
  }
}
/deep/ .el-carousel__indicator {
  width: 14px;
  height: 14px;
  padding: 0;
  opacity: 0.8;
  border-radius: 50%;
  margin: 0 10px;
}
/deep/ .el-carousel__indicator button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #f7e0d3;
}
/deep/ .el-carousel__indicators .is-active > button {
  opacity: 1 !important;
  background: #ff8933 !important;
}

/deep/ .el-carousel__arrow {
  display: none;
}
.w200{width:200px}
.w40{width: 40px}
.w42{width: 42px}
.w67{width: 67px}
.w48{width: 48px}
.w35{width: 35px}
.w50{width: 50px}
.h50{height: 50px}
.h52{height: 52px}
.h285{height: 285px}
.mt54{margin-top:54px}
.mt69{margin-top:69px}
.carousel-height310{
  width: 100%;
  height: 310px;
  display: block;
  opacity: 0;
}
/deep/ .el-carousel__container{
  height: auto!important;
}
.ml105{
  margin-left: 105px
}
.w617{
  width:617px
}
.w160{
  width:160px
}

</style>